import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import type { AdvancedSearchResultInteractedMetadata } from './advanced-search-result-interacted';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

export type SummarizeInChatButtonClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	location: 'searchResult';
	metadata: AdvancedSearchResultInteractedMetadata;
	position?: number;
};

export const onSummarizeInChatButtonClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	location,
	metadata,
	position,
}: SummarizeInChatButtonClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}SummarizeInChatButton`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			location,
			metadata,
			position,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
